import React from 'react'
import { useTranslation } from 'react-i18next'
import { useDispatch } from 'react-redux'
import { KibButtonNew } from '@chewy/kib-controls-react'
import { KibCloseIcon } from '@chewy/kib-icons-react'
import { KibContainer, KibGrid, KibGridItem } from '@chewy/kib-layout-react'

import DocumentPreview from '~/components/dashboard/admin/catalog/documents/DocumentPreview'
import { print } from '~/store/duck/print'

import { useChatContainer } from '../context/ChatContainerContext'

import styles from './AttachmentPreview.module.scss'

const AttachmentPreview = () => {
  const dispatch = useDispatch()
  const { t } = useTranslation('Common')
  const { selectedAttachment, setSelectedAttachment } = useChatContainer()

  const handleClose = () => {
    setSelectedAttachment(null)
  }

  const handlePrint = () => {
    if (selectedAttachment?.fileUrl) {
      dispatch(print(selectedAttachment.fileUrl))
    }
  }

  return (
    <>
      {selectedAttachment && (
        <KibContainer className={styles.attachmentPreviewCard}>
          <KibGrid
            className={styles.attachmentHeader}
            data-testid="attachment-header"
          >
            <KibGridItem className={styles.fileName}>
              {selectedAttachment.name}
            </KibGridItem>
            <KibGridItem>
              <KibButtonNew
                iconOnly
                emphasis="tertiary"
                icon={<KibCloseIcon />}
                theme="utility"
                onClick={handleClose}
              >
                {t('Common:CLOSE_ACTION')}
              </KibButtonNew>
            </KibGridItem>
          </KibGrid>
          <KibContainer
            className={styles.attachmentPreview}
            data-testid="attachment-preview"
          >
            <DocumentPreview hideTopButtons document={selectedAttachment} />
          </KibContainer>
          <KibGrid
            className={styles.attachmentFooter}
            data-testid="attachment-footer"
          >
            <KibGridItem>
              <KibButtonNew onClick={handlePrint}>
                {t('Common:PRINT_ACTION')}
              </KibButtonNew>
            </KibGridItem>
            <KibGridItem>
              <KibButtonNew
                download
                emphasis="secondary"
                href={selectedAttachment.fileUrl}
              >
                {t('Common:DOWNLOAD_ACTION')}
              </KibButtonNew>
            </KibGridItem>
            <KibGridItem>
              <KibButtonNew emphasis="tertiary" onClick={handleClose}>
                {t('Common:CANCEL_ACTION')}
              </KibButtonNew>
            </KibGridItem>
          </KibGrid>
        </KibContainer>
      )}
    </>
  )
}

export default AttachmentPreview
